import PrismicImg from "./PrismicImg";
export default PrismicImg;
